import { useRouter } from "next/router";
import queryString from "query-string";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
}

const Pagination: React.FC<PaginationProps> = ({ currentPage, totalPages }) => {
  const router = useRouter();

  // Function to create URL with updated page number
  const createPageUrl = (page: number) => {
    const query = { ...router.query, page };
    const queryStr = queryString.stringify(query);
    return `${router.pathname}?${queryStr}`;
  };

  const handlePageChange = (page: number) => {
    router.push(createPageUrl(page));
  };

  return (
    <div className="flex justify-center mt-8 flex-wrap">
      {currentPage > 1 && (
        <a
          href={createPageUrl(currentPage - 1)}
          onClick={(e) => {
            e.preventDefault();
            handlePageChange(currentPage - 1);
          }}
          className="px-4 py-2 mr-2 my-1 bg-gray-300 rounded hover:bg-gray-400 cursor-pointer"
        >
          Previous
        </a>
      )}
      {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
        <a
          key={page}
          href={createPageUrl(page)}
          onClick={(e) => {
            e.preventDefault();
            handlePageChange(page);
          }}
          className={`px-4 py-2 mx-1 my-1 ${
            page === currentPage
              ? "bg-[#5bb953] text-white"
              : "bg-gray-300 hover:bg-gray-400"
          } rounded cursor-pointer`}
        >
          {page}
        </a>
      ))}
      {currentPage < totalPages && (
        <a
          href={createPageUrl(currentPage + 1)}
          onClick={(e) => {
            e.preventDefault();
            handlePageChange(currentPage + 1);
          }}
          className="px-4 py-2 ml-2 my-1 bg-gray-300 rounded hover:bg-gray-400 cursor-pointer"
        >
          Next
        </a>
      )}
    </div>
  );
};

export default Pagination;
